import clsx from "clsx";
import type { ReactNode } from "react";
import { formatCurrency } from "@/lib/documentCalc";

export function KalkSumRow({
  label,
  value,
  currency,
  bold,
  muted,
  accent,
  separator,
}: {
  label: string;
  value: number;
  currency: string;
  bold?: boolean;
  muted?: boolean;
  accent?: boolean;
  separator?: boolean;
}) {
  return (
    <div
      className={clsx(
        "gd-kalk-sum-row",
        bold && "gd-kalk-sum-row--bold",
        muted && "gd-kalk-sum-row--muted",
        accent && "gd-kalk-sum-row--accent",
        separator && "gd-kalk-sum-row--separator",
      )}
    >
      <span className="gd-kalk-sum-row__label">{label}</span>
      <span className="gd-kalk-sum-row__value">{formatCurrency(value, currency)}</span>
    </div>
  );
}

export function KalkSumStack({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={clsx("gd-kalk-sum-stack", className)}>{children}</div>;
}
